<template>
  <div v-if="!!agency && !!agency.slug" class="tour-pricing">
    <div v-if="updateTourPricing" class="loader-tour-container">
      <v-loader />
    </div>
    <v-loader v-if="status === 'loading'" />

    <template v-else>
      <div class="d-flex justify-content-end w-100 mb-24">
        <div class="d-flex gap-8">
          <div class="tooltip-wrapper">
            <v-button class="btn-icon w-fit" size="sm" variant="primary" @click="inVoiceSummaryModal">
              <v-icon icon="pdf" size="sm" space="me-12" />
              {{ $t("tourPricing.invoiceDetail") }}
            </v-button>
            <div class="tooltip-text">
              {{ $t("tourPricing.invoiceTooltip") }}
            </div>
          </div>
          <v-button class="btn-icon w-fit" size="sm" variant="primary" @click="soldTour">
            <v-icon icon="check" size="sm" space="me-12" />
            {{ $t("tourBooking.sold") }}</v-button
          >
          <v-button class="btn-icon w-fit" size="sm" variant="primary" @click="cancelTour">
            <v-icon icon="close" size="xs" space="me-12" />
            {{ $t("tourBooking.cancel") }}</v-button
          >
          <v-button class="btn-icon w-fit" size="sm" variant="primary" @click="openSendNotificationsModalAll">
            <v-icon icon="sent" size="sm" space="me-12" />
            {{ $t("tourBooking.sendNotification") }}
          </v-button>
        </div>
      </div>
      <the-tour-pricing-billing
        v-model:gross="pricing.total.grossPrice"
        v-model:markup="pricing.total.markup"
        v-model:net="pricing.total.netPrice"
        v-model:quote="quotePrice"
        :lock="lock"
        :agency="agency.slug"
        :invoice-amount="invoiceRemaingAmount"
        :case-id="Number(caseId)"
        :tour-id="Number(tourId)"
        :invoice-list-data="invoiceListData"
        is-total
        @update-total-pricing="setTotalPricing"
        @load-tour-pricing="loadTourPricing"
        @update-quote-price="updateQuotePrice($event)"
        @updated-total-type-pricing="setTotalTypePricing($event, 'plane')"
        @invoiceList="invoiceList"
        @toggle-lock="toggleLock"
        @open-off-canvas="openCreateBillingInvoiceOffCanvas"
      />

      <div
        v-for="(type, index) in pricing.items.filter(
          (item) => !item.name.startsWith('null') && !item.name.startsWith('unknown')
        )"
        :key="index"
        class="item-list mb-56"
      >
        <div
          :aria-controls="`pricing-collapse-${type.name}`"
          :data-bs-target="`#pricing-collapse-${type.name}`"
          aria-expanded="true"
          class="resource-header accordion-toggle align-items-center"
          data-bs-toggle="collapse"
        >
          <div class="mb-24 d-flex align-items-center">
            <div
              class="d-flex justify-content-between ms-8"
              v-if="type.name !== 'transport' && type.name !== 'transfer'"
            >
              <v-checkbox
                v-model="checkValueSupplier"
                :for-key="`supplier-all-${type.name}-check`"
                :input-id="`supplier-all-${type.name}-check`"
                :label="' '"
                class="form-check-inline d-flex align-items-center m-0"
                label-class="ms-0 ps-8 ps-md-16 pe-8"
                @update:model-value="toggleSelectButton(`pricing-collapse-${type.name}`, type)"
              />
            </div>
            <div class="bg-secondary rounded-xs ms-xl-24 me-8">
              <v-icon :icon="getAssociatedIcon(type.name.split('-')[0])" size="xxl" space="p-12 text-white" />
            </div>
            <h3 class="h4 ff-secondary mb-0">
              {{ findConceptByKey("supplier.type", type.name.split("-")[0]).name }} - {{ $t("tourPricing.profit") }}
            </h3>
          </div>

          <v-icon class="accordion-icon" icon="chevron-up" size="xl" />
        </div>
        <div :id="`pricing-collapse-${type.name}`" class="resources-container accordion-body collapse show p-0 pb-16">
          <div class="suppliers-body">
            <template v-for="(supplier, index) in type.suppliers" :key="index">
              <div class="supplier-container d-flex w-100">
                <div class="w-auto px-0 ps-4 px-lg-8">
                  <div class="d-flex flex-column align-items-center py-20">
                    <v-checkbox
                      v-model="supplier.invoiceChecked"
                      :for-key="`supplier-${type.name}-check`"
                      :input-id="`supplier-${type.name}-check`"
                      :label="' '"
                      class="form-check-inline d-flex align-items-center m-0"
                      label-class="ms-0 ps-8 ps-md-16 pe-8"
                      @update:model-value="
                        checkAllSupplierItems(supplier, type.name, supplier.invoiceChecked, supplier.id, 'all')
                      "
                    />
                  </div>
                </div>
                <div class="supplier-data p-8 ps-0 ps-xl-12 p-xl-12 w-100">
                  <div
                    :id="`collapse-header-${type.name}-${index}`"
                    :aria-controls="`collapse-${type.name}-${index}`"
                    :data-bs-target="`#collapse-${type.name}-${index}`"
                    aria-expanded="true"
                    class="d-flex justify-content-between align-items-center accordion-toggle flex-wrap gx-12 w-100"
                    data-bs-toggle="collapse"
                  >
                    <div class="td w-100">
                      <div class="d-flex align-items-center">
                        <div class="image-container rounded-sm bg-tertiary me-12">
                          {{ supplier.name.charAt(0) }}
                        </div>

                        <div class="py-12 fw-medium">
                          {{ supplier.name }}
                        </div>
                        <span
                          v-if="supplier.isConnectedToHolded"
                          class="ms-12 btn btn-success btn-icon p-1"
                          style="cursor: pointer;"
                          title="Click to reset Holded connection"
                          @click.stop.prevent="resetHoldedConnection(supplier)"
                        >
                          <v-icon icon="check" size="sm" />
                        </span>
                      </div>
                      <v-icon class="accordion-icon" icon="chevron-up" size="xl" />
                    </div>
                  </div>
                  <div class="td d-flex w-100">
                    <div class="hidden-conatiner"></div>
                    <div class="td supplier-info align-items-center row">
                      <div v-if="!!supplier.siteUrl" class="text-sm d-flex pt-0 col-12 col-lg-2">
                        <a
                          :aria-label="supplier.siteUrl"
                          :href="supplier.siteUrl"
                          class="btn-link text-nowrap text-sm"
                          data-bs-target
                          data-bs-toggle="collapse"
                          rel="noopener noreferrer"
                          @click.prevent.stop="openWebsite(supplier.siteUrl)"
                        >
                          {{ $t("general.shared.viewWebsite") }}
                        </a>
                      </div>
                      <div v-else class="text-sm d-flex pt-0 empty-section col-12 col-lg-2">{{}}</div>
                      <div class="col-12 col-lg-3">
                        <template v-if="supplier.bookingType === 'Other'">
                          <a
                            :aria-label="$t('general.shared.bookingBy')"
                            :href="supplier.bookingTypeMeta"
                            class="resource-link btn-link text-sm"
                            rel="noopener noreferrer"
                            target="_blank"
                            @click.prevent.stop
                          >
                            {{ $t("general.shared.bookingBy") }} : {{ supplier.bookingTypeMeta }}
                          </a>
                        </template>
                        <template v-else-if="supplier.bookingType === 'Email'">
                          <a
                            :aria-label="$t('general.shared.bookingBy')"
                            :href="supplier.bookingTypeMeta"
                            class="resource-link btn-link text-sm"
                            rel="noopener noreferrer"
                            target="_blank"
                            @click.prevent.stop
                          >
                            {{ $t("general.shared.bookingBy") }} {{ supplier.bookingType }}
                          </a>
                        </template>
                        <template v-else-if="supplier.bookingType === 'Portal'">
                          <a
                            :aria-label="$t('general.shared.bookingBy')"
                            :href="supplier.bookingTypeMeta"
                            class="resource-link btn-link text-sm"
                            rel="noopener noreferrer"
                            target="_blank"
                            @click.prevent.stop="openWebsite(supplier.bookingTypeMeta)"
                          >
                            {{ $t("general.shared.bookingBy") }} {{ supplier.bookingType }}
                          </a>
                        </template>
                        <template v-else-if="supplier.bookingType === 'Promo code'">
                          <a
                            :aria-label="$t('general.shared.promoCode')"
                            :href="supplier.bookingTypeMeta"
                            class="resource-link btn-link text-sm"
                            rel="noopener noreferrer"
                            target="_blank"
                            @click.prevent.stop
                          >
                            {{ $t("general.shared.promoCode") }} : {{ supplier.bookingTypeMeta }}
                          </a>
                        </template>
                        <template v-else-if="supplier.bookingType === 'Website'">
                          <a
                            aria-label="website"
                            :href="supplier.bookingTypeMeta"
                            class="resource-link btn-link text-sm"
                            rel="noopener noreferrer"
                            target="_blank"
                            @click.prevent.stop
                          >
                            {{ $t("general.shared.bookingBy") }} {{ supplier.bookingType }}
                          </a>
                        </template>
                        <template v-else>
                          <span class="badge btn-danger fw-normal">
                            {{ $t("general.shared.bookingTypeNotFound") }}
                          </span>
                        </template>
                      </div>
                      <div class="ps-lg-0 col-12 col-lg-4">
                        <div v-if="!supplier.email" class="pe-16">
                          <span class="badge bg-danger fw-normal">{{ $t("tourBooking.supplierNoEmail") }}</span>
                        </div>
                        <div v-if="supplier.typeEmail === 'never'" class="pe-16">
                          <span class="badge bg-danger fw-normal">
                            {{ $t("general.shared.notNotificationsSentMail") }}
                          </span>
                        </div>
                        <div v-if="supplier.typeEmail !== 'never' && supplier.email">{{}}</div>
                      </div>
                      <div v-if="!!supplier.paymentMethod" class="col-12 col-lg-3">
                        <div v-if="supplier.paymentMethod === 'bank_transfer' && supplier.account === null">
                          <span class="badge bg-danger fw-normal">
                            {{ $t("general.shared.supplierAccountNotFound") }}
                          </span>
                        </div>
                        <a
                          :aria-label="$t('general.shared.paymentBy')"
                          href=""
                          v-else-if="supplier.paymentMethod !== 'payment_link'"
                          class="resource-link btn-link text-sm"
                          rel="noopener noreferrer"
                          target="_blank"
                          @click.prevent.stop
                        >
                          {{
                            supplier.paymentMethod.charAt(0).toUpperCase() +
                            supplier.paymentMethod.split("_").join(" ").slice(1)
                          }}
                          {{ supplier.paymentDate }}
                        </a>
                        <template v-else>
                          <a
                            v-if="isPaymentLinkAvailable(supplier)"
                            :aria-label="$t('general.shared.paymentBy')"
                            :href="getPaymentLink(supplier)"
                            class="resource-link btn-link"
                            rel="noopener noreferrer"
                            target="_blank"
                            @click.prevent.stop="openWebsite(getPaymentLink(supplier))"
                          >
                            {{
                              supplier.paymentMethod.charAt(0).toUpperCase() +
                              supplier.paymentMethod.split("_").join(" ").slice(1)
                            }}
                            {{ supplier.paymentDate }}
                          </a>
                          <a
                            v-else
                            :aria-label="$t('general.shared.paymentBy')"
                            href=""
                            class="resource-link btn-link text-sm"
                            rel="noopener noreferrer"
                            @click.prevent.stop
                          >
                            {{
                              supplier.paymentMethod.charAt(0).toUpperCase() +
                              supplier.paymentMethod.split("_").join(" ").slice(1)
                            }}
                            {{ supplier.paymentDate }}
                          </a>
                        </template>
                      </div>
                      <div v-else class="col-12 col-lg-3">
                        <span class="badge bg-danger fw-normal">
                          {{ $t("general.shared.noPaymentMethod") }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex send-notification align-self-start justify-content-end gap-8 mt-8 me-16">
                    <v-button
                      :class="supplier.notes !== null ? 'cutom-notes' : ''"
                      class="btn-icon w-fit align-self-center"
                      size="sm"
                      variant="primary"
                      @click="openCustomNotesModal(supplier)"
                    >
                      <v-icon icon="comment" size="sm" />
                    </v-button>

                    <v-button
                      class="btn-icon w-fit align-self-center"
                      size="sm"
                      variant="primary"
                      @click="
                        openSendNotificationsModal();
                        checkAllSupplierItems(
                          supplier,
                          type.name,
                          (supplier.invoiceChecked = true),
                          supplier.id,
                          'all'
                        );
                      "
                    >
                      <v-icon icon="sent" size="sm" />
                    </v-button>
                  </div>
                  <div :id="`collapse-${type.name}-${index}`" class="accordion-body collapse show p-0">
                    <div class="d-none d-lg-block">
                      <div class="resources-profit-header">
                        <div class="d-flex w-100 pe-28 text-sm">
                          <div class="w-05 th p-0 p-xxl-8">
                            <span :aria-label="$t('tourBooking.selectResource')" />
                          </div>
                          <div class="th w-30">
                            {{ $t("general.shared.name") }}
                          </div>

                          <!-- <div v-if="type.name === 'hotel'" class="w-10 th ps-0 ps-xxl-8">
                            {{ $t("tourPricing.nights") }}
                          </div>
                          <div class="w-10 th">{{ $t("tourPricing.dayNumberShort") }}</div> -->
                          <div class="w-05 th">{{ $t("tourPricing.quantityShort") }}</div>
                          <div class="w-20 th">{{ $t("tourPricing.dates") }}</div>
                          <div class="w-10 fit th">{{ $t("tourPricing.netPrice") }}</div>
                          <div class="w-10 fit th">Booking</div>
                          <div class="w-10 fit th">Payment</div>
                          <div class="w-10 fit th">Invoice</div>
                        </div>
                      </div>

                      <div class="suppliers-body">
                        <div
                          v-for="(itemResource, itemResourceIndex) in supplier.itemResourcesGrouped"
                          :key="itemResourceIndex"
                          :class="{ 'bg-gray-200': itemResourceIndex % 2 !== 0 }"
                          class="wrapper"
                        >
                          <div class="d-flex justify-content-between align-items-center w-100">
                            <div class="row align-items-center gx-12 text-sm w-100 pe-24">
                              <div
                                class="w-05 td d-flex align-items-center px-0 px-xxl-8"
                                @mouseover="setHoveredElement(itemResource.id)"
                                @mouseleave="setHoveredElement(0)"
                              >
                                <v-tri-state-checkbox
                                  v-model="itemResource.invoiceChecked"
                                  :for-key="`resource-group-${itemResource.id}-check`"
                                  :input-id="`resource-group-${itemResource.id}-check`"
                                  :label="' '"
                                  class="form-check-inline d-flex align-items-center m-0"
                                  label-class="ms-0"
                                  @update:model-value="checkSupplierResourceGroup(supplier, itemResource)"
                                />
                              </div>

                              <div
                                v-if="itemResource.resources.length > 1"
                                :aria-controls="`collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                                :data-bs-target="`#collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                                aria-expanded="false"
                                class="td accordion-toggle collapsed cusror-pointer w-30"
                                data-bs-toggle="collapse"
                                @mouseover="setHoveredElement(itemResource.id)"
                                @mouseleave="setHoveredElement(0)"
                              >
                                <div class="d-flex align-items-center">
                                  <div
                                    class="fw-semi py-12"
                                    v-if="
                                      itemResource.resources.length > 1 &&
                                      type.name !== 'hotel' &&
                                      !checkAllSupplierWithSameID(itemResource.resources)
                                    "
                                  >
                                    {{ $t("general.shared.various") }} {{ type.name }}
                                  </div>
                                  <div class="fw-semi py-12" v-else>{{ itemResource.name }}</div>
                                  <div :class="{ 'icon-container': !(itemResource.id === hoveredId) }">
                                    <div class="d-flex py-12">
                                      <v-button
                                        class="p-4"
                                        size="sm"
                                        variant="icon"
                                        @click="setCurrentItem(itemResource)"
                                      >
                                        <v-icon icon="pencil" />
                                      </v-button>
                                      <v-button class="p-4" size="sm" variant="icon" @click="deleteItem(itemResource)">
                                        <v-icon icon="trash" />
                                      </v-button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                v-else
                                class="td w-30 cursor-pointer"
                                @mouseover="setHoveredElement(itemResource.id)"
                                @mouseleave="setHoveredElement(0)"
                              >
                                <div class="d-flex align-items-center">
                                  <div class="py-12">{{ itemResource.name }}</div>
                                  <div :class="{ 'icon-container': !(itemResource.id === hoveredId) }">
                                    <div class="d-flex py-12">
                                      <v-button
                                        class="p-4"
                                        size="sm"
                                        variant="icon"
                                        @click="setCurrentItem(itemResource)"
                                      >
                                        <v-icon icon="pencil" />
                                      </v-button>
                                      <v-button class="p-4" size="sm" variant="icon" @click="deleteItem(itemResource)">
                                        <v-icon icon="trash" />
                                      </v-button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- <div v-if="type.name === 'hotel'" class="w-10 td ps-0 ps-xxl-8">
                                <template v-if="itemResource.type === 'hotel'">
                                  {{ calculateNights(itemResource.date, itemResource.endDate) }}
                                </template>

                                <template v-else> - </template>
                              </div>

                              <div class="w-10 td">
                                {{ itemResource.stage }}
                              </div> -->

                              <div class="w-05 td" :class="itemResource.resources.length > 1 ? 'fw-semi' : ''">
                                {{ itemResource.quantity }}
                              </div>

                              <div
                                class="w-20 td d-flex flex-column"
                                :class="itemResource.resources.length > 1 ? 'fw-semi' : ''"
                              >
                                <span
                                  v-if="
                                    itemResource.resources.length > 1 &&
                                    type.name !== 'hotel' &&
                                    !checkAllSupplierWithSameID(itemResource.resources)
                                  "
                                >
                                  N/A
                                </span>
                                <template v-else>
                                  <span>{{ getDayName(itemResource.date) }}</span>
                                  <span>
                                    {{ $str.formatDateTime(itemResource.date, settings.formatDate) }}
                                    <template v-if="itemResource.type === 'hotel'">
                                      -
                                      <template v-if="!!itemResource.endDate">
                                        {{ $str.formatDateTime(itemResource.endDate, settings.formatDate) }}
                                      </template>

                                      <template v-else>
                                        {{ $t("general.shared.noEndDate") }}
                                      </template>
                                    </template>
                                  </span>
                                </template>
                              </div>

                              <!-- isGroupIndividual -->
                              <v-pricing-and-status-update
                                :id="itemResource.id"
                                v-model:amount-paid="itemResource.amountPaid"
                                v-model:amount-pending="itemResource.amountPending"
                                v-model:gross="itemResource.grossPrice"
                                v-model:mark-to-pay="itemResource.markToPay"
                                v-model:markup="itemResource.markup"
                                v-model:net="itemResource.netPrice"
                                v-model:net-validated="itemResource.netValidated"
                                v-model:payment-complete="itemResource.paymentComplete"
                                v-model:payment-partial="itemResource.paymentPartial"
                                v-model:payment-pending="itemResource.paymentPending"
                                v-model:split-payment="itemResource.splitPayment"
                                v-model:tour-day-item-resources="itemResource.resources"
                                v-model:payment-status="itemResource.paymentStatus"
                                v-model:reservation-status="itemResource.reservationStatus"
                                v-model:invoice-status="itemResource.invoiceStatus"
                                :is-updated-by-supplier="itemResource.isUpdatedBySupplier"
                                :supplier-price="itemResource.supplierPrice"
                                :is-price-validated="itemResource.isPriceValidated"
                                :account="supplier.account"
                                :agency="agency.slug"
                                :case-id="Number(caseId)"
                                :payment-method="supplier.paymentMethod"
                                :tour-day-id="itemResource.tourDayId"
                                :tour-day-item-resource-ids="itemResource.tourDayItemResourceIds"
                                :tour-id="Number(tourId)"
                                is-group-individual
                                @update-total-pricing="setTotalPricing"
                                @update-group-type="setGroupTypePricing($event, type)"
                                @updated-group-individual-paid="recalculateGroupPaid(itemResource, false)"
                                @update-item-resource-reservation-status="itemResource.reservationStatus = $event"
                                @update-item-resource-payment-status="itemResource.paymentStatus = $event"
                                @update-item-resource-invoice-status="itemResource.invoiceStatus = $event"
                                @update-tour-price-change="updateTourPricingChnage($event)"
                                @load-tour-pricing="loadTourPricing"
                              />
                            </div>

                            <div
                              v-if="itemResource.resources.length > 1"
                              :aria-controls="`collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                              :data-bs-target="`#collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                              aria-expanded="false"
                              class="accordion-toggle collapsed"
                              data-bs-toggle="collapse"
                            >
                              <v-icon class="accordion-icon" icon="chevron-up" />
                            </div>
                          </div>

                          <div
                            v-if="itemResource.resources.length > 1"
                            :id="`collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                            class="accordion-body collapse p-0"
                          >
                            <div
                              v-for="(tourDayItemResource, index) in itemResource.resources"
                              :key="index"
                              class="row align-items-center gx-12 text-sm pe-36 dashed py-16"
                            >
                              <div class="w-05 td ps-16">
                                <v-checkbox
                                  :id="`supplier-resource-${type.name}-check`"
                                  v-model="tourDayItemResource.invoiceChecked"
                                  :for-key="`supplier-resource-${type.name}-check`"
                                  :label="' '"
                                  class="form-check-inline d-flex align-items-center m-0"
                                  label-class="ms-0"
                                  @update:model-value="checkSupplierResource(itemResource, supplier)"
                                />
                              </div>

                              <div class="td w-30">
                                <div class="py-12 fw-medium">{{ tourDayItemResource.name }}</div>
                              </div>

                              <!-- <div v-if="type.name === 'hotel'" class="w-10 td">
                                {{ calculateNights(tourDayItemResource.date, tourDayItemResource.endDate) }}
                              </div>

                              <div class="w-10 td">
                                {{ itemResource.stage }}
                              </div> -->

                              <div class="w-05 td">1</div>
                              <div class="w-20 td d-flex flex-column">
                                <span>{{ getDayName(tourDayItemResource.date) }}</span>
                                <span>
                                  {{ $str.formatDateTime(tourDayItemResource.date, settings.formatDate) }}
                                  <template v-if="tourDayItemResource.type === 'hotel'">
                                    -
                                    <template v-if="!!tourDayItemResource.endDate">
                                      {{ $str.formatDateTime(tourDayItemResource.endDate, settings.formatDate) }}
                                    </template>

                                    <template v-else>
                                      {{ $t("general.shared.noEndDate") }}
                                    </template>
                                  </template>
                                </span>
                              </div>

                              <!-- isIndividual -->
                              <v-pricing-and-status-update
                                :id="tourDayItemResource.id"
                                v-model:amount-paid="tourDayItemResource.amountPaid"
                                v-model:amount-pending="tourDayItemResource.amountPending"
                                v-model:gross="tourDayItemResource.grossPrice"
                                v-model:mark-to-pay="tourDayItemResource.markToPay"
                                v-model:markup="tourDayItemResource.markup"
                                v-model:net="tourDayItemResource.netPrice"
                                v-model:net-validated="tourDayItemResource.netValidated"
                                v-model:payment-status="tourDayItemResource.paymentStatus"
                                v-model:reservation-status="tourDayItemResource.reservationStatus"
                                v-model:invoice-status="tourDayItemResource.invoiceStatus"
                                v-model:split-payment="tourDayItemResource.splitPayment"
                                v-model:tour-day-item-resources="itemResource.resources"
                                :is-updated-by-supplier="tourDayItemResource.isUpdatedBySupplier"
                                :is-price-validated="tourDayItemResource.isPriceValidated"
                                :supplier-price="itemResource.supplierPrice"
                                :account="supplier.account"
                                :agency="agency.slug"
                                :case-id="Number(caseId)"
                                :payment-method="supplier.paymentMethod"
                                :tour-day-id="tourDayItemResource.tourDayId"
                                :tour-day-item="itemResource"
                                :tour-day-item-id="tourDayItemResource.tourDayItemId"
                                :tour-day-item-resource="tourDayItemResource"
                                :tour-day-item-resource-id="tourDayItemResource.id"
                                :tour-day-item-resource-ids="[tourDayItemResource.id]"
                                :tour-id="Number(tourId)"
                                is-individual
                                @update-total-pricing="setTotalPricing"
                                @updated-individual="recalculateGroupIndividualPricing(itemResource)"
                                @update-group-type="setGroupTypePricing($event, type)"
                                @updated-individual-net-validated="recalculateGroupBulk(itemResource, 'netValidated')"
                                @updated-individual-mark-to-pay="recalculateGroupBulk(itemResource, 'markToPay')"
                                @updated-individual-paid="recalculateGroupPaid(itemResource, true)"
                                @updated-individual-split-payment="recalculateGroupPaid(itemResource, false)"
                                @update-item-resource-reservation-status="
                                  tourDayItemResource.reservationStatus = $event
                                "
                                @update-item-resource-payment-status="tourDayItemResource.paymentStatus = $event"
                                @update-item-resource-invoice-status="tourDayItemResource.invoiceStatus = $event"
                                @update-tour-price-change="updateTourPricingChnage($event)"
                                @load-tour-pricing="loadTourPricing"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="td d-flex justify-content-between align-items-baseline pt-16 pb-24 pe-36">
                          <div class="sub-container w-50">
                            <template class="d-flex flex-column">
                              <div class="d-flex justify-content-between">
                                <span class="fw-bold">
                                  {{ $t("general.shared.payAmount") }} : {{ $t("general.shared.euroShort") }}
                                  {{ formatPrice(totalPayablePriceDayTour(supplier.name, supplier.itemResourcesGrouped)) }}
                                </span>

                                <span class="fw-bold">
                                  {{ $t("general.shared.pendingAmount") }} : {{ $t("general.shared.euroShort") }}
                                  {{ formatPrice(totalPendingPriceDayTour(supplier.name, supplier.itemResourcesGrouped)) }}
                                </span>

                                <span class="fw-bold">
                                  {{ $t("general.shared.paidAmount") }} : {{ $t("general.shared.euroShort") }}
                                  {{ formatPrice(totalAmountPaid(supplier.name, supplier.itemResourcesGrouped)) }}
                                </span>
                              </div>
                            </template>
                          </div>
                          <div class="sub-container w-40">
                            <v-supplier-product-price-update
                              :agency="agency.slug"
                              :case-id="Number(caseId)"
                              :tour-id="Number(tourId)"
                              v-model:common-net-price="supplier.comonNetPrice"
                              v-model:net-validated="supplier.netValidated"
                              v-model:mark-to-pay="supplier.isSplitted"
                              v-model:is-splitted="supplier.isSplitted"
                              v-model:amount-paid="supplier.amountPaid"
                              v-model:amount-pending="supplier.amountPending"
                              :tour-day-item-id="supplier.tourDayItemIds"
                              :supplier-id="supplier.id"
                              :supplier-price="supplier.supplierPrice"
                              :is-price-validated="supplier.isPriceValidated"
                              :is-updated-by-supplier="supplier.isUpdatedBySupplier"
                              @update-tour-price-change="updateTourPricingChnage($event)"
                              @load-tour-pricing="loadTourPricing($event)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-column d-lg-none suppliers-body p-0">
                      <div class="suppliers-body">
                        <div
                          v-for="(itemResource, itemResourceIndex) in supplier.itemResourcesGrouped"
                          :key="itemResourceIndex"
                          :class="{ 'bg-gray-200': itemResourceIndex % 2 !== 0 }"
                          class="wrapper ps-8"
                        >
                          <div class="d-flex justify-content-between align-items-center w-100">
                            <div class="d-flex align-items-center gx-12 text-sm w-100 pe-32">
                              <v-tri-state-checkbox
                                v-model="itemResource.invoiceChecked"
                                :for-key="`resource-group-${itemResource.id}-check`"
                                :input-id="`resource-group-${itemResource.id}-check`"
                                :label="' '"
                                class="form-check-inline d-flex align-items-center m-0"
                                label-class="ms-0"
                                @update:model-value="checkSupplierResourceGroup(supplier, itemResource)"
                              />

                              <div class="w-100 ps-4">
                                <div
                                  :class="{ 'icon-container': !(itemResource.id === hoveredId) }"
                                  @mouseover="setHoveredElement(itemResource.id)"
                                  @mouseleave="setHoveredElement(0)"
                                >
                                  <div class="d-flex mt-4">
                                    <v-button
                                      class="p-4"
                                      size="sm"
                                      variant="icon"
                                      @click="setCurrentItem(itemResource)"
                                    >
                                      <v-icon icon="pencil" />
                                    </v-button>
                                    <v-button class="p-4" size="sm" variant="icon" @click="deleteItem(itemResource)">
                                      <v-icon icon="trash" />
                                    </v-button>
                                  </div>
                                </div>
                                <div
                                  :aria-controls="`collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                                  :data-bs-target="`#collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                                  aria-expanded="false"
                                  class="accordion-toggle collapsed fw-semi py-4"
                                  data-bs-toggle="collapse"
                                  @mouseover="setHoveredElement(itemResource.id)"
                                  @mouseleave="setHoveredElement(0)"
                                >
                                  <span>{{ $t("general.shared.name") }}: </span>
                                  <span>{{ itemResource.name }}</span>
                                </div>

                                <div
                                  v-if="type.name === 'hotel'"
                                  class="fw-semi py-4"
                                  @mouseover="setHoveredElement(itemResource.id)"
                                  @mouseleave="setHoveredElement(0)"
                                >
                                  <span>{{ $t("tourPricing.nights") }}: </span>

                                  <template v-if="itemResource.type === 'hotel'">
                                    {{ calculateNights(itemResource.date, itemResource.endDate) }}
                                  </template>

                                  <template v-else> - </template>
                                </div>

                                <div class="fw-semi py-4">
                                  <span>{{ $t("tourPricing.dayNumber") }}: </span>
                                  <span>{{ itemResource.stage }}</span>
                                </div>

                                <div class="fw-semi py-4">
                                  <span>{{ $t("tourPricing.quantity") }}: </span>
                                  <span>{{ itemResource.quantity }}</span>
                                </div>

                                <div class="fw-semi py-4">
                                  <span>{{ $t("tourPricing.dates") }}: </span>

                                  <span>
                                    <span class="me-4">{{ getDayName(itemResource.date) }}</span>
                                    {{ $str.formatDateTime(itemResource.date, settings.formatDate) }}
                                    <template v-if="itemResource.type === 'hotel'">
                                      -
                                      <template v-if="!!itemResource.endDate">
                                        {{ $str.formatDateTime(itemResource.endDate, settings.formatDate) }}
                                      </template>

                                      <template v-else>
                                        {{ $t("general.shared.noEndDate") }}
                                      </template>
                                    </template>
                                  </span>
                                </div>

                                <!-- isGroupIndividual -->
                                <v-pricing-and-status-update
                                  :id="itemResource.id"
                                  v-model:amount-paid="itemResource.amountPaid"
                                  v-model:amount-pending="itemResource.amountPending"
                                  v-model:gross="itemResource.grossPrice"
                                  v-model:mark-to-pay="itemResource.markToPay"
                                  v-model:markup="itemResource.markup"
                                  v-model:net="itemResource.netPrice"
                                  v-model:net-validated="itemResource.netValidated"
                                  v-model:payment-complete="itemResource.paymentComplete"
                                  v-model:payment-partial="itemResource.paymentPartial"
                                  v-model:payment-pending="itemResource.paymentPending"
                                  v-model:split-payment="itemResource.splitPayment"
                                  v-model:payment-status="itemResource.paymentStatus"
                                  v-model:reservation-status="itemResource.reservationStatus"
                                  v-model:invoice-status="itemResource.invoiceStatus"
                                  v-model:tour-day-item-resources="itemResource.resources"
                                  :is-updated-by-supplier="itemResource.isUpdatedBySupplier"
                                  :is-price-validated="itemResource.isPriceValidated"
                                  :supplier-price="itemResource.supplierPrice"
                                  :account="supplier.account"
                                  :agency="agency.slug"
                                  :case-id="Number(caseId)"
                                  :payment-method="supplier.paymentMethod"
                                  :tour-day-id="itemResource.tourDayId"
                                  :tour-day-item-resource-ids="itemResource.tourDayItemResourceIds"
                                  :tour-id="Number(tourId)"
                                  class="w-100 is-mobile"
                                  is-group-individual
                                  @update-total-pricing="setTotalPricing"
                                  @update-group-type="setGroupTypePricing($event, type)"
                                  @updated-group-individual-paid="recalculateGroupPaid(itemResource, false)"
                                  @update-item-resource-reservation-status="itemResource.reservationStatus = $event"
                                  @update-item-resource-payment-status="itemResource.paymentStatus = $event"
                                  @update-item-resource-invoice-status="itemResource.invoiceStatus = $event"
                                  @update-tour-price-change="updateTourPricingChnage($event)"
                                  @load-tour-pricing="loadTourPricing"
                                />
                              </div>
                            </div>

                            <div
                              v-if="itemResource.resources.length > 1"
                              :aria-controls="`collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                              :data-bs-target="`#collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                              aria-expanded="false"
                              class="accordion-toggle collapsed"
                              data-bs-toggle="collapse"
                            >
                              <v-icon class="accordion-icon" icon="chevron-up" />
                            </div>
                          </div>

                          <div
                            v-if="itemResource.resources.length > 1"
                            :id="`collapse-tour-day-item-resource-${itemResource.id}-dropdown`"
                            class="accordion-body collapse p-0 pt-28 ps-16"
                          >
                            <div
                              v-for="(tourDayItemResource, index) in itemResource.resources"
                              :key="index"
                              class="d-flex text-sm pe-32 dashed py-16"
                            >
                              <v-checkbox
                                :id="`supplier-resource-${type.name}-check`"
                                v-model="tourDayItemResource.invoiceChecked"
                                :for-key="`supplier-resource-${type.name}-check`"
                                :label="' '"
                                class="form-check-inline d-flex align-items-center m-0"
                                label-class="ms-0"
                                @update:model-value="checkSupplierResource(itemResource, supplier)"
                              />

                              <div class="fw-medium">
                                <div class="py-4">
                                  <span>{{ $t("general.shared.name") }}: </span>
                                  <span>{{ tourDayItemResource.name }}</span>
                                </div>

                                <div v-if="type.name === 'hotel'" class="py-4">
                                  <span>{{ $t("tourPricing.nights") }}: </span>
                                  <span>
                                    {{ calculateNights(tourDayItemResource.date, tourDayItemResource.endDate) }}
                                  </span>
                                </div>

                                <div class="py-4">
                                  <span>{{ $t("tourPricing.dayNumber") }}: </span>
                                  {{ itemResource.stage }}
                                </div>

                                <div class="py-4">
                                  <span>{{ $t("tourPricing.quantity") }}: {{ tourDayItemResource.quantity || 1 }}</span>
                                </div>

                                <div class="py-4">
                                  <span>{{ $t("tourPricing.dates") }}: </span>

                                  <span>
                                    <span class="me-4">{{ getDayName(tourDayItemResource.date) }}</span>
                                    {{ $str.formatDateTime(tourDayItemResource.date, settings.formatDate) }}
                                    <template v-if="tourDayItemResource.type === 'hotel'">
                                      -
                                      <template v-if="!!tourDayItemResource.endDate">
                                        {{ $str.formatDateTime(tourDayItemResource.endDate, settings.formatDate) }}
                                      </template>

                                      <template v-else>
                                        {{ $t("general.shared.noEndDate") }}
                                      </template>
                                    </template>
                                  </span>
                                </div>

                                <!-- isIndividual -->
                                <v-pricing-and-status-update
                                  :id="tourDayItemResource.id"
                                  v-model:amount-paid="tourDayItemResource.amountPaid"
                                  v-model:amount-pending="tourDayItemResource.amountPending"
                                  v-model:gross="tourDayItemResource.grossPrice"
                                  v-model:mark-to-pay="tourDayItemResource.markToPay"
                                  v-model:markup="tourDayItemResource.markup"
                                  v-model:net="tourDayItemResource.netPrice"
                                  v-model:net-validated="tourDayItemResource.netValidated"
                                  v-model:payment-status="tourDayItemResource.paymentStatus"
                                  v-model:reservation-status="tourDayItemResource.reservationStatus"
                                  v-model:invoice-status="tourDayItemResource.invoiceStatus"
                                  v-model:split-payment="tourDayItemResource.splitPayment"
                                  v-model:tour-day-item-resources="itemResource.resources"
                                  :is-updated-by-supplier="tourDayItemResource.isUpdatedBySupplier"
                                  :is-price-validated="tourDayItemResource.isPriceValidated"
                                  :supplier-price="itemResource.supplierPrice"
                                  :account="supplier.account"
                                  :agency="agency.slug"
                                  :case-id="Number(caseId)"
                                  :payment-method="supplier.paymentMethod"
                                  :tour-day-id="tourDayItemResource.tourDayId"
                                  :tour-day-item="itemResource"
                                  :tour-day-item-id="tourDayItemResource.tourDayItemId"
                                  :tour-day-item-resource="tourDayItemResource"
                                  :tour-day-item-resource-id="tourDayItemResource.id"
                                  :tour-day-item-resource-ids="[tourDayItemResource.id]"
                                  :tour-id="Number(tourId)"
                                  class="is-mobile w-100"
                                  is-individual
                                  @update-total-pricing="setTotalPricing"
                                  @updated-individual="recalculateGroupIndividualPricing(itemResource)"
                                  @update-group-type="setGroupTypePricing($event, type)"
                                  @updated-individual-net-validated="recalculateGroupBulk(itemResource, 'netValidated')"
                                  @updated-individual-mark-to-pay="recalculateGroupBulk(itemResource, 'markToPay')"
                                  @updated-individual-paid="recalculateGroupPaid(itemResource, true)"
                                  @updated-individual-split-payment="recalculateGroupPaid(itemResource, false)"
                                  @update-item-resource-reservation-status="
                                    tourDayItemResource.reservationStatus = $event
                                  "
                                  @update-item-resource-payment-status="tourDayItemResource.paymentStatus = $event"
                                  @update-item-resource-invoice-status="tourDayItemResource.invoiceStatus = $event"
                                  @update-tour-price-change="updateTourPricingChnage($event)"
                                  @load-tour-pricing="loadTourPricing"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="td d-flex flex-column align-items-lg-center flex-lg-column pt-16 pb-24 pe-36">
                          <div class="d-flex justify-content-between">
                            <span class="fw-bold">
                              {{ $t("general.shared.payAmount") }} : {{ $t("general.shared.euroShort") }}
                              {{ formatPrice(totalPayablePriceDayTour(supplier.name, supplier.itemResourcesGrouped)) }}
                            </span>

                            <span class="fw-bold">
                              {{ $t("general.shared.pendingAmount") }} : {{ $t("general.shared.euroShort") }}
                              {{ formatPrice(totalPendingPriceDayTour(supplier.name, supplier.itemResourcesGrouped)) }}
                            </span>

                            <span class="fw-bold">
                              {{ $t("general.shared.paidAmount") }} : {{ $t("general.shared.euroShort") }}
                              {{ formatPrice(totalAmountPaid(supplier.name, supplier.itemResourcesGrouped)) }}
                            </span>
                          </div>
                          <v-supplier-product-price-update
                            :agency="agency.slug"
                            :case-id="Number(caseId)"
                            :tour-id="Number(tourId)"
                            v-model:common-net-price="supplier.comonNetPrice"
                            v-model:net-validated="supplier.netValidated"
                            v-model:mark-to-pay="supplier.markToPay"
                            v-model:is-splitted="supplier.isSplitted"
                            v-model:amount-paid="supplier.amountPaid"
                            v-model:amount-pending="supplier.amountPending"
                            :tour-day-item-id="supplier.tourDayItemIds"
                            :supplier-id="supplier.id"
                            :supplier-price="supplier.supplierPrice"
                            :is-price-validated="supplier.isPriceValidated"
                            :is-updated-by-supplier="supplier.isUpdatedBySupplier"
                            is-mobile
                            @update-tour-price-change="updateTourPricingChnage($event)"
                            @load-tour-pricing="loadTourPricing"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="type-total">
          <div class="d-flex flex-column flex-md-row w-100 align-items-center ps-16 pe-16 ps-md-64">
            <div class="w-05 d-none d-md-block" />
            <div class="w-70 text-xl fw-bold text-uppercase text-center text-md-start">
              {{
                $t("tourPricing.supplierTypeTotal", {
                  supplierType: findConceptByKey("supplier.type", type.name).name,
                })
              }}
            </div>

            <!-- isGroupType -->
            <v-pricing-update
              :id="type.name"
              v-model:gross="type.total.grossPrice"
              v-model:markup="type.total.markup"
              v-model:net="type.total.netPrice"
              :agency="agency.slug"
              :case-id="Number(caseId)"
              :total-type="type.name"
              :tour-id="Number(tourId)"
              class="is-mobile"
              is-group-type
              @updated-total-type-pricing="setTotalTypePricing($event, type)"
              @update-total-pricing="setTotalPricing"
              @load-tour-pricing="loadTourPricing"
            />
          </div>

          <!-- <div class="d-flex justify-content-end">
            <div class="text-start preview-container">
              <button class="btn-sm btn-primary btn align-self-end" type="button" @click="openModal">
                {{ $t("general.shared.preview") }}
              </button>
            </div>
          </div> -->
        </div>
      </div>

      <div
        v-if="!!currentTour && !!currentTour.id && statusTotalPricing === 'loaded'"
        class="pricing-total-container item-list"
      >
        <div class="total-header">
          <div class="mb-24 d-flex align-items-center justify-content-between">
            <div>
              <h3 class="text-xl text-uppercase ff-secondary mb-0">{{ $t("tourPricing.total") }}</h3>
            </div>
          </div>
        </div>

        <div class="pricing-total">
          <div class="d-flex flex-column flex-md-row w-100 align-items-center ps-16 pe-16 ps-md-64">
            <div class="w-05 d-none d-md-block" />
            <div class="w-70 d-none d-md-block" />

            <!-- isTotal -->
            <v-pricing-update
              :id="`tour-${tourId}`"
              v-model:gross="pricing.total.grossPrice"
              v-model:markup="pricing.total.markup"
              v-model:net="pricing.total.netPrice"
              :agency="agency.slug"
              :case-id="Number(caseId)"
              :tour-id="Number(tourId)"
              class="is-mobile"
              is-total
              @update-total-pricing="setTotalPricing"
              @load-tour-pricing="loadTourPricing"
            />
          </div>
        </div>
      </div>
      <div v-if="!!currentTour && !!currentTour.id" class="mt-24">
        <div class="total-header">
          <div class="mb-24 d-flex align-items-center justify-content-between">
            <div>
              <h3 class="text-xl text-uppercase ff-secondary mb-0">{{ $t("tourPricing.quotePrice") }}</h3>
            </div>
            <div class="d-flex align-item-center w-15">
              <v-form-input
                autocomplete="off"
                form-type="input-group"
                id="quote-price"
                v-model="quotePrice"
                onwheel="return false;"
                right-addon="€"
                step=".01"
                type="number"
                :disabled="lock"
                @blur="updateQuotePrice('input')"
              />
              <div class="lock-btn">
                <v-button
                  class="btn-primary p-4"
                  variant="icon"
                  @click="
                    toggleLock();
                    updateQuotePrice('button');
                  "
                >
                  <component :is="lock ? 'TheLock' : 'TheUnLock'" />
                </v-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <the-pricing-invoice-create-off-canvas
      v-if="offCanvasToShow === 'the-pricing-invoice-create-off-canvas'"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :items="items"
      :pricing="pricing"
      :total-invoice="totalInvoice"
      :invoice-amount="invoiceRemaingAmount"
      :quote-price="quotePrice"
      :tour-id="Number(tourId)"
      @closed="closeOffCanvas"
      @invoiceList="invoiceList"
    />

    <div v-if="showLoader" class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ $t("general.button.loading") }}</span>
    </div>

    <the-hotel-pricing-summary-modal
      v-if="showmodal"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :summary-data="summaryData"
      :tour-id="Number(tourId)"
      @closed="closeModal"
      @load-tour-pricing="loadTourPricing"
    />

    <the-tour-day-item-details-off-canvas
      v-if="offCanvasToShow === 'the-tour-day-item-details-off-canvas'"
      :agency="agency.slug"
      :client-tour-id="Number(caseId)"
      :status="statusTourDayItem"
      :tour-id="Number(tourId)"
      @closed="
        closeOffCanvas();
        clearCurrentTourDayItem();
        loadTourPricing();
      "
      @emit-reload-tour="loadTourPricing"
    />
    <the-tour-statuses-send-notification-off-canvas
      v-if="offCanvasToShow === 'the-tour-statuses-send-notification-off-canvas'"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :resources="resources"
      :supplier-data-for-email="supplierDataForEmail"
      :tour-id="Number(tourId)"
      @closed="closeOffCanvas()"
      @reload-items="loadTourPricing"
    />

    <the-confirmation-modal
      v-if="showConfirmationModal"
      :title="ModalTitle"
      :btn-loading="btnLoading"
      @confirm="onConfirm"
      @closed="closeConfirmModal"
    />

    <the-custom-notes-off-canvas
      v-if="offCanvasToShow === 'the-custom-notes-off-canvas'"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :tour-id="Number(tourId)"
      :supplier="supplierIdForCustomNote"
      @closed="closeOffCanvas()"
      @reload-items="loadTourPricing"
    />

    <the-invoice-summary-modal
      v-if="inVoiceSummary"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :tour-id="Number(tourId)"
      :pricing="pricing"
      :paymentMethod="paymentMethod"
      @closed="closeInvoiceSummaryModal()"
      @reload-items="loadTourPricing"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "pinia";
import { VCheckbox, VFormInput } from "@uniqoders/form";
import { DateTime } from "luxon";
import api from "@/api";
import { TYPE } from "vue-toastification";
import { useAuthStore } from "@/stores/auth";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VDropdown from "@/components/vendor/basic/dropdown/VDropdown.vue";
import { findConceptByKey, mapConcepts } from "@/helpers/ConceptHelper";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import { useUserStore } from "@/stores/user";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import ThePricingInvoiceCreateOffCanvas from "@/components/pricing/ThePricingInvoiceCreateOffCanvas.vue";
import useOffCanvasUtils from "@/helpers/OffCanvasUtils";
import TourDayItemResource from "@/api/objects/TourDayItemResource";
import { useAppStore } from "@/stores/app";
import { usePriceStore } from "@/stores/priceCalculation";
import TheHotelPricingSummaryModal from "@/components/case/parts/TheHotelPricingSummaryModal.vue";
import useConcepts from "@/helpers/Concepts";
import VPricingUpdate from "@/components/pricing/VPricingUpdate.vue";
import VTriStateCheckbox from "@/components/vendor/basic/form/VTriStateCheckbox.vue";
import { calculateAllNetValidated, calculateAllPaymentStatus, calculatePriceGroup, formatPrice } from "@/composables/pricing";
import TheTourDayItemDetailsOffCanvas from "@/components/tour/TheTourDayItemDetailsOffCanvas.vue";
import TheTourStatusesSendNotificationOffCanvas from "@/components/reservation/TheTourStatusesSendNotificationOffCanvas.vue";
import VPricingAndStatusUpdate from "@/components/pricing/VPricingAndStatusUpdate.vue";
import VSupplierProductPriceUpdate from "@/components/pricing/VSupplierProductPriceUpdate.vue";
import TheConfirmationModal from "@/components/modal/TheConfirmationModal.vue";
import TheLock from "@/assets/icons/TheLock.vue";
import TheUnLock from "@/assets/icons/TheUnLock.vue";
import TheCustomNotesOffCanvas from "@/components/notes/TheCustomNotesOffCanvas.vue";
import TheTourPricingBilling from "@/components/pricing/TheTourPricingBilling.vue";
import TheInvoiceSummaryModal from "@/components/invoice/TheInvoiceSummaryModal.vue";

export interface IItemsTypes {
  types: any[];
  resourceIds: number[];
}

interface IPrice {
  grossPrice: number;
  markup: number;
  netPrice: number;
}

export interface IPricingItemSupplierResource {
  amountPaid: number | string;
  amountPending: number;
  date: string;
  endDate: string | DateTime;
  grossPrice: number;
  id: number;
  invoiceChecked: boolean;
  invoiceStatus: string;
  isOptional: false;
  markup: number;
  markToPay: boolean;
  modelId: number;
  modelType: string;
  name: string;
  netPrice: number;
  netValidated: boolean;
  pax: number;
  paymentStatus: string;
  quantity: number;
  reservationStatus: string;
  splitPayment: boolean;
  stage: number;
  supplierResourceId: string | number;
  tourDayId: number;
  tourDayItemId: number;
  type: string;
}

export interface IPricingItemSupplierResourceGrouped {
  account: string;
  amountPaid: number | string;
  amountPending: number;
  date: string;
  endDate: string;
  grossPrice: number;
  id: string;
  invoiceChecked: boolean;
  markup: number;
  markToPay: boolean | "mixed";
  name: string;
  netPrice: number;
  netValidated: boolean | "mixed";
  paymentComplete: boolean | "mixed";
  paymentPartial: boolean | "mixed";
  paymentPending: boolean | "mixed";
  paymentCancelled: boolean | "mixed";
  paymentMethod: string;
  paymentDate: string;
  bookingType: string;
  bookingTypeMeta: string;
  quantity: number;
  resources: IPricingItemSupplierResource[];
  splitPayment: boolean | "mixed";
  stage: number;
  tourDayId: number;
  tourDayItemIds: number[];
  tourDayItemResourceIds: number[];
  type: string;
  typeResource: string;
  supplierPrice: string;
  paymentStatus: string;
  reservationStatus: string;
  invoiceStatus: string;
}

interface IPricingItemSupplier {
  account: string;
  email: string;
  id: string | number;
  invoiceChecked: boolean | "mixed";
  itemResourcesGrouped: IPricingItemSupplierResourceGrouped[];
  mapUrl: string;
  name: string;
  paymentMethod: string;
  phone: string;
  preferredLanguage: string;
  priceRange: number;
  siteUrl: string;
  type: string;
  typeEmail: string;
  amountPaid: number | string;
  amountPending: number;
  comonNetPrice: number;
  netValidated: boolean;
  markToPay: boolean;
  isSplitted: boolean;
  tourDayItemIds: number;
}

interface IPricingItems {
  name: string;
  suppliers: IPricingItemSupplier[];
  total: IPrice;
}

interface IPricing {
  items: IPricingItems[];
  total: IPrice;
}

interface SelectAllToggleState {
  [key: string]: boolean;
}

export type HotelDataType = {
  hotelName: string;
  paidAmount?: number;
  pendingAmount?: number;
  payableAmount?: number;
};

export default defineComponent({
  name: "TheTourPricing",
  components: {
    VTriStateCheckbox,
    VPricingUpdate,
    ThePricingInvoiceCreateOffCanvas,
    TheHotelPricingSummaryModal,
    VLoader,
    VIcon,
    VButton,
    VCheckbox,
    VDropdown,
    TheTourDayItemDetailsOffCanvas,
    TheTourStatusesSendNotificationOffCanvas,
    VPricingAndStatusUpdate,
    VSupplierProductPriceUpdate,
    VFormInput,
    TheLock,
    TheUnLock,
    TheConfirmationModal,
    TheCustomNotesOffCanvas,
    TheTourPricingBilling,
    TheInvoiceSummaryModal,
  },
  props: {
    caseId: {
      type: String,
      required: true,
    },
    tourId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const userStore = useUserStore();
    return {
      findConceptByKey,
      ...useOffCanvasUtils(),
      ...useConcepts(),
      userStore,
      formatPrice,
    };
  },
  data() {
    return {
      status: "loading",
      statusTotalPricing: "loading",
      pricing: {} as IPricing,
      resources: [] as IPricingItemSupplierResource[],
      totalNetPrice: 0,
      totalGrossPrice: 0,
      totalMarkup: 0,
      totalInvoice: 0,
      showLoader: false as boolean,
      summaryData: [] as HotelDataType[],
      showmodal: false as boolean,
      requestedUpdatePricing: true,
      test: null as any,
      checkbox: false as boolean | "mixed",
      items: {
        types: [] as any[],
        resourceIds: [] as number[],
      } as any,
      hoveredId: 0 as number,
      statusTourDayItem: "loading" as string,
      supplierDataForEmail: [] as IPricingItemSupplierResourceGrouped[],
      updateTourPricing: false as boolean,
      selectAllToggle: {} as SelectAllToggleState,
      lock: false as boolean,
      quotePrice: 0 as number,
      initialQuotePrice: 0 as number,
      ModalTitle: "" as string,
      showConfirmationModal: false as boolean,
      currentAction: null as string | null,
      checkValueSupplier: false as boolean,
      supplierIdForCustomNote: 0 as number,
      btnLoading: false as boolean,
      invoiceListData: [] as any,
      invoiceRemaingAmount: {} as any,
      inVoiceSummary: false as boolean,
      paymentMethod: {} as any,
      paymentMethodTypes: [
        { key: "holded", label: this.$t("general.payment.payViaHolded") },
        { key: "wise", label: this.$t("general.payment.payViaWise") },
      ],
    };
  },
  computed: {
    ...mapState(useAppStore, ["settings"]),
    ...mapState(useAuthStore, ["agency"]),
    ...mapState(useUserStore, ["currentTour"]),
    itemTypes(): any {
      if (!!this.concepts && this.concepts["supplier.type"]) {
        return mapConcepts(this.concepts["supplier.type"]);
      }

      return [];
    },
  },
  async created() {
    await this.loadTourPricing();
    await this.invoiceList();
    this.status = "loaded";
  },
  methods: {
    setType(type: object) {
      this.paymentMethod = type;
      this.inVoiceSummary = true;
    },
    checkAllSupplierWithSameID(item: any) {
      if (!item || item.length === 0) return false;

      const firstId = item[0].supplierResourceId;
      for (const obj of item) {
        if (obj.supplierResourceId !== firstId) {
          return false;
        }
      }
      return true;
    },
    async invoiceList() {
      this.updateTourPricingChnage(true);
      const response = await api.invoice.invoiceList(this.agency.slug, Number(this.caseId), Number(this.tourId));
      this.invoiceListData = response.data;
      this.invoiceRemaingAmount = response.meta;
      this.updateTourPricingChnage(false);
    },

    async doResetHoldedConnection(supplier: any) {
      const tourDayItemIds = supplier.itemResourcesGrouped
        ?.flatMap((g: any) => g.tourDayItemIds || [])
        ?.filter((id: any, index: number, self: any[]) => self.indexOf(id) === index);

      if (!tourDayItemIds?.length) return;

      try {
        await api.invoice.resetHoldedConnection(
          this.agency.slug,
          Number(this.caseId),
          Number(this.tourId),
          { tourDayItemIds }
        );

        supplier.isConnectedToHolded = false;
        supplier.itemResourcesGrouped?.forEach((g: any) => {
          g.isConnectedToHolded = false;
        });

        this.$toast.success("Holded connection reset");
      } catch (e: any) {
        this.$toast.error(e?.response?.data?.message || "Failed to reset Holded connection");
      }
    },

    async resetHoldedConnection(supplier: any) {
      await this.$modal?.confirm({
        title: "Reset Holded connection",
        text: `This will reset the Holded connection for ${supplier.name} and allow the resources to be re-integrated.`,
        leftButtonClasses: "btn-tertiary",
        confirmButtonText: this.$t("general.button.confirm"),
        confirmButtonCallback: () => this.doResetHoldedConnection(supplier),
      });
    },

    getDayName(date: string) {
      return DateTime.fromISO(date).toFormat("cccc");
    },
    toggleLock() {
      this.lock = !this.lock;
    },
    toggleSelectButton(collapseId: any, supplierType: any) {
      if (supplierType.name !== "transfer" && supplierType.name !== "transport") {
        const collapseElement = document.getElementById(collapseId);
        collapseElement?.classList?.remove("collapsing");
        collapseElement?.classList?.add("show");
        this.selectAllToggle[supplierType.name] = !this.selectAllToggle[supplierType.name];
        this.checkValueSupplier = this.selectAllToggle[supplierType.name];
        if (!this.selectAllToggle[supplierType.name]) {
          this.deselectAllResources(supplierType);
        } else {
          this.checkAllResources(supplierType);
        }
      }
    },
    updateTourPricingChnage(value: boolean) {
      this.updateTourPricing = value;
    },
    isPaymentLinkAvailable(supplier: any) {
      return (
        supplier?.itemResourcesGrouped?.map((i) => i.paymentLink !== null && i.paymentLink)?.filter(Boolean)[0] !==
        undefined
      );
    },
    getPaymentLink(supplier: any) {
      return supplier?.itemResourcesGrouped?.map((i) => i.paymentLink !== null && i.paymentLink)?.filter(Boolean)[0];
    },
    setTotalTypePricing(response: any, pricingType: IPricingItems) {
      if (pricingType?.name === "plane") {
        this.invoiceList();
      }
      const data =
        pricingType === "plane" ? this.pricing?.items?.filter((e: any) => e.name === "plane")[0] : pricingType;
      data.suppliers.forEach((supplier: IPricingItemSupplier) => {
        supplier.itemResourcesGrouped.forEach((itemResources: IPricingItemSupplierResourceGrouped) => {
          response.forEach((responseResource: any) => {
            const itemResource = itemResources.resources.find(
              (resource: IPricingItemSupplierResource) => resource.id === responseResource.id
            );

            if (!!itemResource) {
              itemResource.grossPrice = responseResource.gross_value;
              itemResource.markup = responseResource.markup_value;
              itemResource.netPrice = responseResource.net_value;

              const { netPrice, grossPrice } = calculatePriceGroup(itemResources.resources);

              itemResources.grossPrice = grossPrice;
              itemResources.markup = responseResource.markup_value;
              itemResources.netPrice = netPrice;
            }
          });
        });
      });
    },
    setGroupTypePricing(
      {
        grossPrice,
        markup,
        netPrice,
      }: {
        grossPrice: number;
        markup: number;
        netPrice: number;
      },
      type: IPricingItems
    ) {
      type.total.grossPrice = grossPrice;
      type.total.markup = markup;
      type.total.netPrice = netPrice;
    },
    setTotalPricing({ grossPrice, markup, netPrice }: { grossPrice: number; markup: number; netPrice: number }) {
      this.statusTotalPricing = "loading";

      this.pricing.total.grossPrice = grossPrice;
      this.pricing.total.markup = markup;
      this.pricing.total.netPrice = netPrice;

      this.statusTotalPricing = "loaded";
    },
    recalculateGroupBulk(itemResource: IPricingItemSupplierResourceGrouped, variable: string) {
      let value: boolean | "mixed" = false;

      const allValue = itemResource.resources.every((item: IPricingItemSupplierResource) => item[variable] === true);

      if (allValue) {
        value = true;
      } else {
        const someValue = itemResource.resources.some((item: IPricingItemSupplierResource) => item[variable] === true);

        if (someValue) {
          value = "mixed";
        }
      }

      itemResource[variable] = value;
    },
    recalculateGroupPaid(itemResource: IPricingItemSupplierResourceGrouped, updatePrices = true) {
      if (updatePrices) {
        const { amountPaid, amountPending } = calculatePriceGroup(itemResource.resources);

        itemResource.amountPaid = amountPaid;
        itemResource.amountPending = amountPending;
      }

      const paymentPartial: boolean | "mixed" = calculateAllPaymentStatus(itemResource.resources, "partial");

      itemResource.netValidated = calculateAllNetValidated(itemResource.resources);
      itemResource.paymentComplete = calculateAllPaymentStatus(itemResource.resources, "complete");
      itemResource.paymentPending = calculateAllPaymentStatus(itemResource.resources, "pending");
      itemResource.paymentPartial = paymentPartial;
      itemResource.paymentCancelled = calculateAllPaymentStatus(itemResource.resources, "cancelled");
      itemResource.splitPayment = paymentPartial;
    },
    recalculateGroupIndividualPricing(itemResource: IPricingItemSupplierResourceGrouped) {
      const { netPrice, grossPrice, markup } = this.calculatePrice(itemResource.resources);

      itemResource.netPrice = netPrice;
      itemResource.markup = markup;
      itemResource.grossPrice = grossPrice;
    },
    calculateNights(initDate: string, endDate: string): number {
      if (!initDate || !endDate) {
        return 0;
      }

      const init = DateTime.fromISO(initDate).startOf("day");
      const end = DateTime.fromISO(endDate).startOf("day");

      return end.diff(init, "days").days;
    },
    openWebsite(url: string) {
      window.open(url, "_blank");
    },
    calculatePrice(tourDayItemResources: TourDayItemResource[] | IPricingItemSupplierResource[]): Record<string, any> {
      // 1. Calculate the net, gross and markup for each type.
      const { netPrice, grossPrice } = calculatePriceGroup(tourDayItemResources);

      let markup: number = ((grossPrice - netPrice) * 100) / netPrice;

      if (markup % 1 !== 0) {
        markup = Number(markup.toFixed(2));
      }

      if (Number.isNaN(markup)) {
        markup = 0;
      }

      return {
        netPrice,
        grossPrice,
        markup,
      };
    },
    mapResourcesToNotification(type: string, id: number) {
      this.resources = [];
      this.supplierDataForEmail = [];

      this.pricing.items.forEach((supplierType: any) => {
        if (supplierType.name === type) {
          supplierType?.suppliers?.forEach((newSupplier: any) => {
            if (newSupplier.id === id) {
              this.supplierDataForEmail.push(newSupplier);
              newSupplier.itemResourcesGrouped.forEach((item: any) => {
                item.resources.forEach((resource: any) => {
                  if (resource.invoiceChecked) {
                    this.resources.push(resource.id);
                  }
                });
              });
            }
          });
        }
      });
    },
    async mapResourcesToNotificationAll() {
      this.resources = [];
      const supplierData: any[] = [];

      this.pricing.items.forEach((supplierType: any) => {
        supplierType?.suppliers?.forEach((newSupplier: any) => {
          supplierData.push(newSupplier);
          newSupplier.itemResourcesGrouped.forEach((item: any) => {
            item.resources.forEach((resource: any) => {
              if (resource.invoiceChecked) {
                this.resources.push(resource.id);
              }
            });
          });
        });
      });
      this.supplierDataForEmail = supplierData;
    },
    checkAllSupplierItems(supplier: any, type: string, checked: boolean, id: number, checboxType: string) {
      supplier.itemResourcesGrouped.forEach((item: any) => {
        item.invoiceChecked = checboxType === "all" ? checked : item.invoiceChecked;
        item.resources.forEach((resource: any) => {
          resource.invoiceChecked = checboxType === "all" ? checked : resource.invoiceChecked;
        });
      });
      this.mapResourcesToNotification(type, id);
    },
    openSendNotificationsModalAll() {
      this.mapResourcesToNotificationAll();

      if (this.resources.length === 0) {
        this.$toast.error(this.$t("tourBooking.noResourcesSelectedMessage"));
      } else {
        this.openOffCanvas("the-tour-statuses-send-notification-off-canvas");
      }
    },
    openSendNotificationsModal() {
      this.openOffCanvas("the-tour-statuses-send-notification-off-canvas");
    },
    openCustomNotesModal(supplier: any) {
      this.supplierIdForCustomNote = supplier;
      this.openOffCanvas("the-custom-notes-off-canvas");
    },
    setHoveredElement(id: number) {
      this.hoveredId = id;
    },
    checkAllResources(type: any) {
      this.pricing.items.forEach((priceType) => {
        if (priceType.name === type.name) {
          priceType.suppliers.forEach((supplier) => {
            supplier.invoiceChecked = true;

            supplier.itemResourcesGrouped.forEach((item) => {
              item.invoiceChecked = true;
              item.resources.forEach((resource) => {
                resource.invoiceChecked = true;
              });
            });
          });
        }
      });
    },
    deselectAllResources(type: any) {
      this.pricing.items.forEach((priceType) => {
        if (priceType.name === type.name) {
          priceType.suppliers.forEach((supplier) => {
            supplier.invoiceChecked = false;

            supplier.itemResourcesGrouped.forEach((item) => {
              item.invoiceChecked = false;
              item.resources.forEach((resource) => {
                resource.invoiceChecked = false;
              });
            });
          });
        }
      });
    },
    setCurrentItem(item: any) {
      const payload = {
        agency: this.agency.slug,
        clientTourId: Number(this.caseId),
        tourId: Number(this.tourId),
        tourDayId: item?.tourDayId,
        tourDayItemId: item?.tourDayItemIds[0],
      };
      this.openItemDetailsOffCanvas(payload);
    },
    async openItemDetailsOffCanvas(data: any) {
      this.statusTourDayItem = "loading";

      if (this.offCanvasToShow !== "the-tour-day-item-details-off-canvas") {
        this.openOffCanvas("the-tour-day-item-details-off-canvas");
      }

      await this.userStore.setCurrentTourDayItem(data);

      this.statusTourDayItem = "loaded";
    },
    async deleteItem(itemResource: any) {
      await this.$modal.delete({
        title: this.$t("tourBuilder.deleteTourDayItemTitle"),
        text: this.$t("tourBuilder.deleteTourDayItemText", {
          dayItem: itemResource?.name,
        }),
        deleteButtonText: this.$t("general.button.delete"),
        rightButtonClasses: "btn-tertiary",
        deleteButtonCallback: () => this.doDeleteItem(itemResource),
      });
    },
    async doDeleteItem(itemResource: any) {
      this.status = "loading";
      const loadingToast = this.$toast.loading(this.$t("general.button.deleting"), "toast-remove-tour-day-item");
      try {
        await api.tourDayItemResource.delete(
          this.agency.slug,
          Number(this.caseId),
          Number(this.tourId),
          itemResource?.tourDayId,
          itemResource?.tourDayItemIds[0],
          itemResource?.tourDayItemResourceIds[0]
        );

        this.loadTourPricing();

        if (!!this.currentTourDayItem && !!this.currentTourDayItem.id && tourDayItemId === this.currentTourDayItem.id) {
          this.$emit("closeItemDetailsOffCanvas");
        }

        this.loadTourPricing();
        this.status = "loaded";

        loadingToast.update("toast-remove-tour-day-item", {
          content: this.$t("tourBuilder.dayItemDeleted"),
          options: {
            type: TYPE.SUCCESS,
            icon: "icon icon-check-circle-fill",
            timeout: 5000,
          },
        });
      } catch (e: any) {
        loadingToast.update("toast-remove-tour-day-item", {
          content: this.$t("tourBuilder.dayItemDeleteError"),
          options: {
            type: TYPE.ERROR,
            icon: "icon icon-exclamation-triangle-fill",
            timeout: 5000,
          },
        });

        console.error(e.response.data);

        this.$toast.error(e.response.data.message);
      }
    },
    clearCurrentTourDayItem() {
      this.userStore.setCurrentTourDayItem(null);
    },
    checkItemsInvoiceChecked(items: any) {
      const isAllCheckTrue = items.every((group: any) => group.invoiceChecked === true);

      if (isAllCheckTrue) {
        return true;
      } else {
        const isAllCheckFalse = items.every((group: any) => group.invoiceChecked === false);

        if (isAllCheckFalse) {
          return false;
        } else {
          return "mixed";
        }
      }
    },
    checkSupplier(supplier: any) {
      supplier.invoiceChecked = this.checkItemsInvoiceChecked(supplier.itemResourcesGrouped);
    },
    checkSupplierResource(itemResourcesGrouped: any, supplier: any) {
      itemResourcesGrouped.invoiceChecked = this.checkItemsInvoiceChecked(itemResourcesGrouped.resources);

      this.checkSupplier(supplier);
    },
    checkSupplierResourceGroup(supplier: any, itemResource: any) {
      itemResource.resources.forEach((resource: any) => {
        resource.invoiceChecked = itemResource.invoiceChecked;
      });

      this.checkSupplier(supplier);
    },
    async loadTourPricing(showLoader = false) {
      if (showLoader) {
        this.showLoader = true;
      }

      if (!!this.agency) {
        const pricing: TourDayItemResource[] = await api.tourPricing.all(this.agency.slug, this.caseId, this.tourId);

        const orderedByTypeAndDate = pricing.group((item: TourDayItemResource) => {
          // Create a unique grouping key by combining type
          const type = item.type || "unknown";
          return `${type}`;
        });

        const pricingItems: IPricingItems[] = Object.keys(orderedByTypeAndDate).map((name: string) => {
          const tourDayItems: TourDayItemResource[] = orderedByTypeAndDate[name];

          // 1. Calculate the net, gross and markup for each type.
          const { netPrice, grossPrice, markup } = this.calculatePrice(tourDayItems);

          // 2. Group items by supplier and tourDayItemId
          const supplierGroups = tourDayItems.reduce((groups: { [key: string]: TourDayItemResource[] }, item) => {
            if (item.resource.supplier) {
              const key = !["hotel"].includes(item.resource.supplier.type)
                ? `${item.resource.supplier.id}`
                : `${item.resource.supplier.id}-${item.tourDayItemId}`;

              if (!groups[key]) {
                groups[key] = [];
              }
              groups[key].push(item);
            }
            return groups;
          }, {});

          // 3. Map grouped suppliers
          const suppliersMapped = Object.keys(supplierGroups).map((groupKey) => {
            const groupItems = supplierGroups[groupKey];
            const supplier = groupItems[0].resource.supplier;

            // // Use Set to ensure unique tourDayItemIds
            // const uniqueTourDayItemIds = new Set<number>();
            // const tourDayItemResources = groupItems.filter((item) => {
            //   if (!uniqueTourDayItemIds.has(item.tourDayItemId)) {
            //     uniqueTourDayItemIds.add(item.tourDayItemId);
            //     return true;
            //   }
            //   return false;
            // });

            const tourDayItemResources = groupItems.map((item) => {
              item.resource = {
                amenities: item.resource.amenities,
                cancellationPolicy: item.resource.cancellationPolicy,
                createdAt: item.resource.createdAt,
                deletedAt: item.resource.deletedAt,
                description: item.resource.description,
                id: item.resource.id,
                name: item.resource.name,
                supplierId: item.resource.supplierId,
                type: item.resource.type,
                updatedAt: item.resource.updatedAt,
                translations: item.resource.translations,
              };
              // item.account = supplier.account;
              // item.paymentMethod = supplier.paymentMethod;
              item.invoiceChecked = false;
              return item;
            });

            this.sortTourDayItemResources(tourDayItemResources);

            const tourDayItemsResourcesGroup: {
              [key: string]: TourDayItemResource[];
            } = tourDayItemResources.reduce((acc, itemResource) => {
              const key =
                itemResource.type === "hotel"
                  ? `${itemResource.resource.id}-${itemResource.date}-${itemResource.endDate}-${itemResource.netPrice}-${itemResource.paymentStatus}-${itemResource.reservationStatus}-${itemResource.invoiceStatus}`
                  : `${itemResource.paymentStatus}-${itemResource.reservationStatus}-${itemResource.invoiceStatus}`;

              if (!acc[key]) {
                acc[key] = [];
              }

              acc[key].push(itemResource);

              return acc;
            }, {});

            const tourDayItemsResourcesGrouped = Object.keys(tourDayItemsResourcesGroup).map((key: string) => {
              const tourDayItemsResourcesGroupMapped = tourDayItemsResourcesGroup[key].map((item) => {
                const isUpdated = !!item.isUpdatedBySupplier;
                const netPrice = isUpdated ? Number(item.supplierPrice) : Number(item.netPrice);
                const markup = Number(item.markup) || 0;
                const grossPrice = isUpdated ? parseFloat((netPrice * (1 + markup / 100)).toFixed(2)) : Number(item.grossPrice);

                const paid = !!item.amountPaid ? Number(item.amountPaid) : 0;
                const quantity = Number(item.quantity) || 1;
                const amountPending = netPrice * quantity - paid;
                return {
                  amountPaid: item.amountPaid,
                  amountPending: amountPending,
                  date: item.date,
                  endDate: item.endDate,
                  grossPrice: grossPrice,
                  id: item.id,
                  invoiceChecked: false,
                  invoiceStatus: item.invoiceStatus,
                  isOptional: item.isOptional,
                  isUpdatedBySupplier: item.isUpdatedBySupplier,
                  supplierPrice: Number(item.supplierPrice),
                  markup: markup,
                  markToPay: false,
                  modelId: item.modelId,
                  modelType: item.modelType,
                  name: item.resource.name,
                  netPrice: netPrice,
                  netValidated: item.netValidated,
                  pax: item.pax,
                  paymentStatus: item.paymentStatus,
                  quantity: quantity,
                  reservationStatus: item.reservationStatus,
                  invoiceStatus: item.invoiceStatus,
                  splitPayment: item.paymentStatus === "partial",
                  stage: item.tourDayItem.stage,
                  supplierResourceId: item.resource.id,
                  tourDayId: item.tourDayItem.tourDayId,
                  tourDayItemId: item.tourDayItemId,
                  type: item.type,
                  paymentLink: item.paymentLink,
                  isBlocked: item.tourDayItem.isBlocked,
                  isSplitted: item.tourDayItem.isSplitted,
                  comonNetPrice: item.tourDayItem.netPrice,
                  isConnectedToHolded: item.tourDayItem.isConnectedToHolded,
                  notes: item.tourDayItem.notes,
                  isPriceValidated: item.tourDayItem.supplierPriceValidated,
                  nReserve: item.nReserve,
                  flightNumber: item.flightNumber,
                  initHour: item.initHour,
                  endHour: item.endHour,
                };
              });

              const { netPrice, grossPrice, amountPaid, amountPending } = calculatePriceGroup(
                tourDayItemsResourcesGroup[key]
              );

              // Calculate net validated of group
              const netValidated: boolean | "mixed" = calculateAllNetValidated(tourDayItemsResourcesGroup[key]);

              // Calculate if all payments in the group are complete
              const paymentComplete: boolean | "mixed" = calculateAllPaymentStatus(
                tourDayItemsResourcesGroup[key],
                "complete"
              );
              const paymentPartial: boolean | "mixed" = calculateAllPaymentStatus(
                tourDayItemsResourcesGroup[key],
                "partial"
              );
              const paymentPending: boolean | "mixed" = calculateAllPaymentStatus(
                tourDayItemsResourcesGroup[key],
                "pending"
              );
              const paymentCancelled: boolean | "mixed" = calculateAllPaymentStatus(
                tourDayItemsResourcesGroup[key],
                "cancelled"
              );

              const ids = tourDayItemsResourcesGroup[key].map((itemResource) => itemResource.id);

              return {
                account: tourDayItemsResourcesGroup[key][0].account,
                amountPaid: amountPaid,
                amountPending: amountPending,
                date: tourDayItemsResourcesGroup[key][0].date,
                endDate: DateTime.fromISO(tourDayItemsResourcesGroup[key][0].endDate),
                grossPrice: grossPrice,
                id: ids.join("-"),
                invoiceChecked: false,
                isUpdatedBySupplier: tourDayItemsResourcesGroup[key][0].isUpdatedBySupplier,
                supplierPrice: Number(tourDayItemsResourcesGroup[key][0].supplierPrice),
                markup: Number(tourDayItemsResourcesGroup[key][0].markup),
                markToPay: false,
                name: tourDayItemsResourcesGroup[key][0].resource.name,
                netPrice: netPrice,
                netValidated: netValidated,
                paymentMethod: tourDayItemsResourcesGroup[key][0].paymentMethod,
                paymentLink: tourDayItemsResourcesGroup[key][0].paymentLink,
                paymentDate: tourDayItemsResourcesGroup[key][0].paymentDate,
                bookingType: tourDayItemsResourcesGroup[key][0].bookingType,
                bookingTypeMeta: tourDayItemsResourcesGroup[key][0].bookingTypeMeta,
                paymentComplete: paymentComplete,
                paymentPartial: paymentPartial,
                paymentPending: paymentPending,
                paymentCancelled: paymentCancelled,
                quantity: tourDayItemsResourcesGroup[key].reduce(
                  (sum, itemResource) => sum + (Number(itemResource.quantity) || 1),
                  0
                ),
                resources: tourDayItemsResourcesGroupMapped,
                splitPayment: paymentPartial,
                stage: tourDayItemsResourcesGroup[key][0].tourDayItem.stage,
                tourDayId: tourDayItemsResourcesGroup[key][0].tourDayItem.tourDayId,
                tourDayItemIds: tourDayItemsResourcesGroup[key].map((itemResource) => itemResource.tourDayItem.id),
                tourDayItemResourceIds: ids,
                type: tourDayItemsResourcesGroup[key][0].type,
                typeResource: tourDayItemsResourcesGroup[key][0].resource.type,
                paymentStatus: tourDayItemsResourcesGroup[key][0].paymentStatus,
                reservationStatus: tourDayItemsResourcesGroup[key][0].reservationStatus,
                invoiceStatus: tourDayItemsResourcesGroup[key][0].invoiceStatus,
                isBlocked: tourDayItemsResourcesGroup[key][0].tourDayItem.isBlocked,
                isSplitted: tourDayItemsResourcesGroup[key][0].tourDayItem.isSplitted,
                comonNetPrice: tourDayItemsResourcesGroup[key][0].tourDayItem.netPrice,
                isConnectedToHolded: tourDayItemsResourcesGroup[key][0].tourDayItem.isConnectedToHolded,
                isPriceValidated: tourDayItemsResourcesGroup[key][0].tourDayItem.supplierPriceValidated,
                notes: tourDayItemsResourcesGroup[key][0].tourDayItem.notes,
                pax: tourDayItemsResourcesGroup[key][0].pax,
                nReserve: tourDayItemsResourcesGroup[key][0].nReserve,
                flightNumber: tourDayItemsResourcesGroup[key][0].flightNumber,
                initHour: tourDayItemsResourcesGroup[key][0].initHour,
                endHour: tourDayItemsResourcesGroup[key][0].endHour,
              };
            });

            // supplier.tourDayItemResources = tourDayItemResources;
            supplier.itemResourcesGrouped = tourDayItemsResourcesGrouped;
            supplier.invoiceChecked = false;

            return {
              account: supplier.account,
              email: supplier.email,
              id: supplier.id,
              invoiceChecked: false,
              itemResourcesGrouped: tourDayItemsResourcesGrouped,
              mapUrl: supplier.mapUrl,
              name: supplier.name,
              paymentMethod: supplier.paymentMethod,
              paymentDate: supplier.paymentDate,
              bookingType: supplier.bookingType,
              bookingTypeMeta: supplier.bookingTypeMeta,
              phone: supplier.phone,
              preferredLanguage: supplier.preferredLanguage,
              priceRange: supplier.priceRange,
              siteUrl: supplier.siteUrl,
              type: supplier.type,
              typeEmail: supplier.typeEmail,
              paymentStatus: tourDayItemsResourcesGrouped[0].paymentStatus,
              isBlocked: tourDayItemsResourcesGrouped[0].isBlocked,
              isSplitted: tourDayItemsResourcesGrouped[0].isSplitted,
              comonNetPrice: tourDayItemsResourcesGrouped[0].comonNetPrice,
              isConnectedToHolded: tourDayItemsResourcesGrouped[0].isConnectedToHolded,
              isPriceValidated: tourDayItemsResourcesGrouped[0].isPriceValidated,
              isUpdatedBySupplier: tourDayItemsResourcesGrouped[0].isUpdatedBySupplier,
              netValidated: tourDayItemsResourcesGrouped[0].netValidated,
              amountPaid: tourDayItemsResourcesGrouped.reduce((total, item) => total + item.amountPaid, 0),
              amountPending: tourDayItemsResourcesGrouped.reduce((total, item) => total + item.amountPending, 0),
              tourDayItemIds: tourDayItemsResourcesGrouped[0].tourDayItemIds[0],
              supplierPrice: tourDayItemsResourcesGrouped[0].supplierPrice,
              notes: tourDayItemsResourcesGrouped[0].notes,
              pax: tourDayItemsResourcesGrouped[0].pax,
            };
          });

          return {
            name,
            suppliers: suppliersMapped,
            total: {
              grossPrice,
              markup,
              netPrice,
            },
          };
        });

        if (!!this.currentTour) {
          const activeResources = pricing.filter((r: any) => !r.isOptional && r.reservationStatus !== 'cancelled');
          const overallTotal = calculatePriceGroup(activeResources);
          this.statusTotalPricing = "loading";
          this.pricing = {
            items: pricingItems,
            total: {
              netPrice: overallTotal.netPrice,
              grossPrice: overallTotal.grossPrice,
              markup: overallTotal.netPrice > 0 ? parseFloat((((overallTotal.grossPrice - overallTotal.netPrice) * 100) / overallTotal.netPrice).toFixed(2)) : 0,
            },
          };
          this.statusTotalPricing = "loaded";
        }
      }

      if (showLoader) {
        this.showLoader = false;
      }
      this.updateTourPricingChnage(false);
    },
    getAssociatedIcon(type: string) {
      let defaultIcon = "compass";

      if (!!type) {
        defaultIcon = this.itemTypes.find((item: any) => item.key === type)?.icon;
      }

      return defaultIcon;
    },
    sortTourDayItemResources(items: TourDayItemResource[]): TourDayItemResource[] {
      return items.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        const dateEndA = new Date(a.endDate);
        const dateEndB = new Date(b.endDate);

        if (dateA.getTime() === dateB.getTime()) {
          if (dateEndA.getTime() === dateEndB.getTime()) {
            return a.id - b.id;
          }

          return dateEndA.getTime() - dateEndB.getTime();
        }

        return dateA.getTime() - dateB.getTime();
      });
    },
    openCreateBillingInvoiceOffCanvas() {
      this.openOffCanvas("the-pricing-invoice-create-off-canvas");
    },
    openCreateInvoiceOffCanvas() {
      this.totalInvoice = 0;
      this.items.types = [];
      this.items.resourceIds = [];
      const allResources: any = [];

      this.pricing.items.forEach((supplierType: IPricingItems) => {
        supplierType.suppliers.forEach((supplier: IPricingItemSupplier) => {
          const supplierData = {
            id: supplier.id,
            name: supplier.name,
          };

          supplier.itemResourcesGrouped.forEach((itemResource: IPricingItemSupplierResourceGrouped) => {
            itemResource.resources.forEach((resource: IPricingItemSupplierResource) => {
              const resourceData = {
                id: resource.supplierResourceId,
                name: resource.name,
              };

              if (resource.invoiceChecked) {
                allResources.push(resource);
                this.items.resourceIds.push(resource.id);

                const typeFounded = this.items.types.find((type: any) => type.name === supplierType.name);

                if (!typeFounded) {
                  const type = {
                    name: supplierType.name,
                    suppliers: [
                      {
                        ...supplierData,
                        itemResources: [
                          {
                            ...resourceData,
                            resources: [resource.id],
                          },
                        ],
                      },
                    ],
                  };

                  this.items.types.push(type);
                } else {
                  const supplierFounded = typeFounded.suppliers.find(
                    (supplierAux: any) => supplierAux.id === supplier.id
                  );

                  if (!supplierFounded) {
                    typeFounded.suppliers.push({
                      ...supplierData,
                      itemResources: [
                        {
                          ...resourceData,
                          resources: [resource.id],
                        },
                      ],
                    });
                  } else {
                    const itemResourceFounded = supplierFounded.itemResources.find(
                      (itemResourceAux: any) => itemResourceAux.id === resource.supplierResourceId
                    );

                    if (!itemResourceFounded) {
                      supplierFounded.itemResources.push({
                        ...resourceData,
                        resources: [resource.id],
                      });
                    } else {
                      itemResourceFounded.resources.push(resource.id);
                    }
                  }
                }
              }
            });
          });
        });
      });

      let totalInvoice = allResources.reduce(
        (sum: number, item: IPricingItemSupplierResource) => sum + (Number(item.grossPrice) || 0),
        0
      );

      if (totalInvoice % 1 !== 0) {
        totalInvoice = Number(totalInvoice.toFixed(2));
      }

      this.totalInvoice = totalInvoice;

      if (allResources.length === 0) {
        this.$toast.error(this.$t("tourPricing.invoice.noResourcesSelectedMessage"));
      } else {
        this.openOffCanvas("the-pricing-invoice-create-off-canvas");
      }
    },
    totalNetPriceTour(data: IPricingItemSupplierResourceGrouped[]): number {
      return data.reduce((total: number, item: IPricingItemSupplierResourceGrouped) => {
        return total + item.netPrice;
      }, 0);
    },
    totalAmountPaid(hotelName: string, data: IPricingItemSupplierResourceGrouped[]): number {
      const hotelData = this.getHotelData(hotelName);
      return data.reduce((total: number, item: IPricingItemSupplierResourceGrouped) => {
        // Convert the netPrice property to a number before adding to the total
        const amountPaidAsNumber = item.amountPaid;
        hotelData.paidAmount = total + amountPaidAsNumber;
        return total + amountPaidAsNumber;
      }, 0);
    },
    totalPendingPriceDayTour(hotelName: string, data: IPricingItemSupplierResourceGrouped[]): number {
      const priceStore = usePriceStore();
      const totalNetPrice = this.totalNetPriceTour(data);
      const totalAmountPaid = this.totalAmountPaid(hotelName, data);

      const hotelData = this.getHotelData(hotelName);

      const dataIds = data.flatMap((item: IPricingItemSupplierResourceGrouped) => item.tourDayItemResourceIds);
      const matchingPrices = priceStore.price.filter((price) => dataIds.includes(price.id));

      if (matchingPrices.length !== 0) {
        const totalReadyToPrice = matchingPrices.reduce((sum, price) => sum + price.readyToPrice, 0);
        hotelData.pendingAmount = totalNetPrice - totalAmountPaid - totalReadyToPrice;
        return hotelData.pendingAmount;
      }
      hotelData.pendingAmount = totalNetPrice - totalAmountPaid;
      return totalNetPrice - totalAmountPaid;
    },
    totalPayablePriceDayTour(hotelName: string, data: IPricingItemSupplierResourceGrouped[]): number {
      const priceStore = usePriceStore();
      const hotelData = this.getHotelData(hotelName);

      const dataIds = data.flatMap((item: IPricingItemSupplierResourceGrouped) => item.tourDayItemResourceIds);

      const matchingPrices = priceStore.price.filter((price) => dataIds.includes(price.id));

      if (matchingPrices.length !== 0) {
        const totalReadyToPrice = matchingPrices.reduce((sum, price) => sum + price.readyToPrice, 0);
        hotelData.payableAmount = totalReadyToPrice;
        return hotelData.payableAmount;
      }

      hotelData.payableAmount = 0;
      return 0;
    },
    getHotelData(hotelName: string): HotelDataType {
      let hotelData = this.summaryData.find((data) => data.hotelName === hotelName);

      if (!hotelData) {
        hotelData = { hotelName };
        this.summaryData.push(hotelData);
      }

      return hotelData;
    },
    openModal() {
      this.showmodal = true;
    },
    closeModal() {
      this.showmodal = false;
    },
    async onConfirm() {
      this.btnLoading = true;
      if (this.currentAction === "updateSold") {
        await this.updateSold();
      } else if (this.currentAction === "updateCancel") {
        await this.updateCancel();
      }
      this.closeConfirmModal();
    },
    closeConfirmModal() {
      this.showConfirmationModal = false;
    },
    async soldTour() {
      this.showConfirmationModal = true;
      this.ModalTitle = this.$t("tourBooking.sold");
      this.currentAction = "updateSold";
    },
    async cancelTour() {
      this.showConfirmationModal = true;
      this.ModalTitle = this.$t("tourBooking.cancel");
      this.currentAction = "updateCancel";
    },
    async updateSold() {
      try {
        const response = await api.tourPricing.sold(this.agency.slug, Number(this.caseId), Number(this.tourId));
        if (response) {
          this.btnLoading = false;
          this.$toast.success(this.$t("general.shared.savedChanges"));
          this.loadTourPricing();
        }
      } catch (e: any) {
        console.error(e);
      }
    },
    async updateCancel() {
      try {
        const response = await api.tourPricing.cancel(this.agency.slug, Number(this.caseId), Number(this.tourId));
        if (response) {
          this.btnLoading = false;
          this.$toast.success(this.$t("general.shared.savedChanges"));
          this.loadTourPricing();
        }
      } catch (e: any) {
        console.error(e);
      }
    },
    async updateQuotePrice(type: string) {
      try {
        // Only check for changes when triggered from input blur
        if (type === "input" && this.quotePrice === this.initialQuotePrice) {
          return; // Do nothing if there is no change
        }
        const data = {
          is_locked: this.lock,
          quote_price: this.quotePrice,
        };
        const response = await api.tourPricing.updateQuotePrice(
          this.agency.slug,
          Number(this.caseId),
          Number(this.tourId),
          data
        );
        if (response) {
          this.$toast.success(this.$t("general.shared.savedChanges"));
          this.getTourData();
        }
      } catch (e: any) {
        console.error(e);
      }
    },
    async getTourData() {
      try {
        const params = {
          expand: ["client", "paxs", "featuredImage", "quotes", "invoicesReceived", "clientTour"],
        };
        const response = await api.tour.retrieve(this.agency.slug, Number(this.caseId), Number(this.tourId), params);

        this.lock = response?.isQuotePriceLocked;
        this.quotePrice = response?.quotePrice;
        this.initialQuotePrice = response?.quotePrice;
      } catch (e: any) {
        console.error(e);
      }
    },
    inVoiceSummaryModal() {
      this.inVoiceSummary = true;
    },
    closeInvoiceSummaryModal() {
      this.inVoiceSummary = false;
    },
  },
  async mounted() {
    const priceStore = usePriceStore();
    priceStore.clearPriceData();
    this.getTourData();
  },
  unmounted() {
    this.userStore.setCurrentTourDayItem(null);
  },
});
</script>

<style lang="scss" scoped>
.preview-container {
  margin-right: 1rem;
  margin-top: 0.5rem;
}

.accordion-toggle {
  cursor: pointer;
}

.status-title {
  height: 49px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
}

.suppliers-header {
  .th {
    padding-left: 2.75rem !important;
  }
}

.suppliers-header,
.resources-profit-header {
  .th {
    padding: 0.5rem 0.375rem;
    font-weight: 500;
    font-size: 0.875rem;

    @media (min-width: 1400px) {
      font-size: 1rem;
    }
  }
}

.suppliers-body {
  .supplier-container {
    border: 1px solid var(--uq-gray-400);
    border-radius: 0.25rem;

    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }

  .supplier-data {
    position: relative;

    .td {
      padding-inline: 0.375rem;
      font-weight: 300;
    }
  }

  .supplier-name {
    font-size: 0.875rem;

    @media (min-width: 992px) {
      font-size: 1rem;
    }

    @media (min-width: 1200px) {
      font-size: 1.125rem;
    }
  }

  .row {
    padding: 0.375rem;
    font-size: 0.875rem;

    @media (min-width: 992px) {
      font-size: 1rem;
    }

    .td {
      padding-inline: 0.375rem;
      font-weight: 300;
    }
  }
}

.item-list {
  .resources-container {
    position: relative;
    margin-bottom: 1rem;
    padding-bottom: 1rem;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 100%;
      background: var(--uq-secondary);
    }
  }

  .type-total,
  .pricing-total {
    padding-block: 1rem;
    border: 1px solid var(--uq-gray-400);
    border-radius: 0.25rem;
  }
}

.spinner-border {
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 1050;
}

.suppliers-body {
  .tour-day-item-resource-container,
  .wrapper {
    position: relative;
    padding-top: 0.75rem;

    &:not(:last-child) {
      padding-bottom: 0.75rem;
    }

    &:not(:last-child):after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 100%;
      background: var(--uq-gray-300);
    }

    &.bg-gray-200 {
      :deep(.form-outline .label span) {
        background-color: #f7f7fc !important;
      }

      :deep(.input-group .input-group-text) {
        background-color: #f0f0f9;
      }
    }

    :deep(.input-group .input-group-text) {
      background-color: #f7f7fc;
    }
  }

  .mobile-view {
    display: none;
  }

  .sub-container {
    width: 44%;

    :deep(.form-control) {
      padding-inline: 1rem;
      min-height: 32px !important;
      height: 32px !important;
    }

    :deep(.input-group-text) {
      height: 32px;
    }
  }

  .form-check-inline {
    margin-top: 8px;
  }

  @media (max-width: 993px) {
    .normal-view {
      display: none;
    }

    .mobile-view {
      display: flex;
    }

    .sub-container {
      width: 100%;
      margin-left: 1rem;
      margin-top: 1rem;
    }
  }
}

.dashed:not(:last-child) {
  padding-bottom: 1rem;
  border-bottom: 1px dashed var(--uq-gray-400);
}

.accordion-toggle {
  .accordion-icon {
    right: 0.5rem;
  }
}

.icon-container {
  display: none;
}

.hover-container:hover .icon-container {
  display: flex;
}

.icon-layout {
  margin-left: -3.5rem;
}

.send-notification {
  position: absolute;
  top: 0.4rem;
  right: 3rem;
}

.supplier-info {
  display: flex;
  justify-content: end;
  margin: 0 auto;
  width: 100%;
  margin-top: -4px;
}

.lock-btn {
  margin-left: 0.5rem;
  align-content: center;
}

.hidden-conatiner {
  width: 2.5rem;
}

.cutom-notes {
  background-color: #32de84;
  border-color: #32de84;
}

.cutom-notes:hover {
  background-color: #32de84;
  border-color: #32de84;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  background-color: #bbe5f1;
  color: black;
  text-align: center;
  padding: 6px 12px;
  border-radius: 6px;
  position: absolute;
  z-index: 1000;
  bottom: 115%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;

  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -6px;
  border-width: 6px;
  border-style: solid;
  border-color: #bbe5f1 transparent transparent transparent;
}

.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
